export default "__VITE_ASSET__2e97c7aa__"